import React from 'react';
import { ContentCard } from '../style';
import PropTypes from 'prop-types';

const DeliveryAddress = ({ order }) => {
  const { address } = order;
  return (
    <ContentCard>
      <div className="header">Delivery address</div>
      <div className="body">
        <h5>
          {address?.street_address}, {address?.state}
        </h5>
      </div>
    </ContentCard>
  );
};

export default DeliveryAddress;

DeliveryAddress.propTypes = {
  order: PropTypes.object.isRequired,
};
